import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, computed, watch, UnwrapRef } from 'vue';
import { useMotion } from '@vueuse/motion';
import { useCountdownClock } from 'util/composables';
import { useModule } from 'src/modules/modules';


export default /*#__PURE__*/_defineComponent({
  __name: 'countdown-seconds',
  props: {
    count: null,
    autostart: { type: Boolean },
    delay: null
  },
  emits: ['end'],
  setup(__props: any, { expose, emit }) {

const { count, autostart = true, delay = 0 } = __props as {
    count: number,
    autostart: boolean,
    delay?: number
}

_useCssVars(_ctx => ({
  "984897a2": (_unref(theme).theme.cardBg)
}))

const { game, theme } = useModule();




const clock = useCountdownClock(game.gameScene as any); //Fuck vue
const secondsRemaining = computed(() => {
    let sec = Math.floor(clock.remaining.value / 1000);
    if (clock.remaining.value === 0){
        return '';
    }
    return `${sec + 1}`;
})

const container = ref<HTMLDivElement>();
const containerMotion = useMotion(container, {
    initial: {
        scale: 0,
        opacity: 0,
        y: 300
    },
    enter: {
        scale: 1,
        opacity: 1,
        y: 0,
        transition: {
            delay: 300,
            duration: 500,
            ease: 'easeOut'
        }
    },
    leave: {
        scale: 0,
        opacity: 0,
        transition: {
            duration: 500,
            ease: 'easeOut'
        } 
    }
})

const countEl = ref<HTMLDivElement>();
watch(() => secondsRemaining.value, () => {
    useMotion(countEl, {
        initial: {
            scale: 0,
            opacity: 0
        },
        enter: {
            scale: 1,
            opacity: 1,
            transition: {
                duration: 350,
                ease: 'easeOut'
            }
        },
    })
})

onMounted(() => {
    if (autostart){
        setTimeout(() => {
            clock.start(count * 1000);
        }, delay);
    }
})

clock.on('end', () => {
    emit('end');
});

expose({
    start: () => {
        if (clock.status.value !== 'running'){
            clock.start(count * 1000);
        }
    },
    leave: () => {
        clock.stop()
        return containerMotion.apply('leave');
    }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "container",
    ref: container,
    class: "k-countdown-seconds-container"
  }, [
    _createElementVNode("div", {
      ref_key: "countEl",
      ref: countEl
    }, _toDisplayString(_unref(secondsRemaining)), 513)
  ], 512))
}
}

})